import { useGetCreatorProducts } from "./useGetCreatorProducts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useCallback, useEffect, useMemo } from "react";
import {
    getStripeAccount,
    refreshStripeAccount
} from "store/stripeConnectAccount/thunks";
import { AppDispatch } from "store/store";

export interface UseUserStripeProps {
    requestImmediately: boolean;
    includeProducts: boolean;
    redirectPath?: string;
}

export const useUserStripeData = ({
    requestImmediately = true,
    includeProducts = false
}: UseUserStripeProps) => {
    const dispatch = useDispatch<AppDispatch>();

    const {
        account,
        details,
        gatedContentStatus,
        isLoading: stripeAccountLoading
    } = useSelector((state: RootState) => state.stripeConnectAccount);

    const href = useMemo(() => "https://dashboard.stripe.com/login", []);
    const target = useMemo(() => "_blank", []);

    const getStripeAccounts = useCallback(() => {
        dispatch(refreshStripeAccount());
    }, [dispatch]);

    // The product data for the stripe account
    const productData = useGetCreatorProducts({
        requestImmediately: requestImmediately && includeProducts,
        stripeAccountLoading,
        stripeAccountId: account?.Id
    });

    useEffect(() => {
        if (requestImmediately) {
            dispatch(getStripeAccount());
        }
    }, [dispatch, requestImmediately]);

    return {
        accountData: {
            account,
            details,
            gatedContentStatus,
            link: {
                target,
                href
            }
        },
        productData,
        loading:
            stripeAccountLoading ||
            (includeProducts && requestImmediately && !productData) ||
            productData?.loading,
        getStripeAccounts
    };
};
